import store from '@/store'

const Checkin = () => import('./Checkin.vue')

export default [
    {
        path: '/checkins/:picacode/gallery_tree/:gallery_id?',
        name: 'gallery-tree',
        meta: {
            requiresAuth: true,
            showBackButton: true,
            showCheckinMenu: true
        },
        component: Checkin,
        beforeEnter: async (to, from, next) => {
            const picacode = to.params.picacode

            try {
                // Check if checkin is already fetched
                const checkin = store.getters['checkinDetail/checkin']

                if (!checkin) {
                    // Redirect to checkin-detail if checkin doesn't exist
                    next({ name: 'checkins-detail', params: { picacode } })
                } else {
                    next()
                }
            } catch (error) {
                console.error('Error fetching checkin:', error)
                // Redirect to checkin-detail on error
                next({ name: 'checkins-detail', params: { picacode } })
            }
        }
    },
]